import { render, staticRenderFns } from "./RelbaseSyncReport.vue?vue&type=template&id=2bdf722d&scoped=true&"
import script from "./RelbaseSyncReport.vue?vue&type=script&lang=js&"
export * from "./RelbaseSyncReport.vue?vue&type=script&lang=js&"
import style0 from "./RelbaseSyncReport.vue?vue&type=style&index=0&id=2bdf722d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdf722d",
  null
  
)

export default component.exports